<div
  class="row pt-3 pb-2 px-2 item pointer-cursor mx-2"
  [ngClass]="{
    'active-item':
      accessPointId === sharedData?.selectedAccessPoint?.accessPointId
  }"
  (click)="unitClickHandler(accessPointId, name, floorId, floorName)"
>
  <div class="col-2 text-center">
    <img src="assets/images/accesspoint-icon.png" class="icon" />
  </div>
  <div class="col-7">
    <div class="col-12 heading2">
      <app-with-tooltip [showHelpCursor]="false">{{ name }}</app-with-tooltip>
    </div>
    <div class="col-12 status">{{ accessPointStatus | titlecase }}</div>
  </div>
  <div
    class="col-3 px-4 text-right setting-icon"
    (click)="unitClickHandler(accessPointId, name, floorId, floorName)"
  >
    <img src="assets/svg/ico-chevron-forward-outline.svg" />
  </div>
</div>
